<template>
    <div class="question mb-4">
        <div class="mb-3">
            <div class="question__title">
                Какие критерии качества дополнительных образовательных программ вы считаете наиболее важными в Вашей организации,  на которые вы обратите внимание при приеме на работу, аттестации или карьерном перемещении?
            </div>
            <div class="question__desc caption">Пожалуйста, оцените  степень важности по 5-бальной шкале, поставив соответствующую цифру в правой колонке, где 1-не важно, 5- наиболее важно.</div>
        </div>

        <table class="table-skills">
            <thead class="table-skills__header">
                <tr>
                    <td>Основные события в компании</td>
                    <td>Оценка важности</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="id in fids" :key="id">
                    <td v-if="list[id].text">{{ list[id].text }}</td>
                    <td class="table-skills__answer">
                        <question-radio
                                has-index
                                :index-offset="0"
                                :isSingleHor="true"
                                v-if="list[id].type === 'radio' && list[id].answers.length"
                                :horizontal="!!list[id].is_horizontal"
                                :items="list[id].answers"
                                @input="$emit('sendAnswer', $event, id)"
                        />
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <question-radio
                                has-index
                                :index-offset="0"
                                :isSingleHor="true"
                                v-if="list[last].type === 'radio' && list[last].answers.length"
                                :horizontal="!!list[last].is_horizontal"
                                :items="list[last].answers"
                                @input="$emit('sendAnswer', $event, last)"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import QuestionRadio from '@/components/question/radio'

    export default {
        components: {
            QuestionRadio
        },
        props: {
            ids: Array
        },
        data () {
            return {
                items: [],
                value: ''
            }
        },
        computed: {
            ...mapGetters('questions', ['questions']),
            fids () {
                return this.ids.slice(0, this.ids.length - 1)
            },
            last () {
                return this.ids[this.ids.length - 1]
            },
            list () {
                let out = {}

                this.questions.forEach(item => {
                    out[item.id] = item
                })

                return out
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .question {
        &__title {}
        &__desc {
            color #777777
        }
    }

    .table-skills {
        width 100%
        border-collapse collapse

        &__header {
            text-align center
        }

        &__answer {
            vertical-align middle
        }

        td {
            padding .5rem 1rem
            border 1px solid rgba(0,0,0,0.42)
        }
    }
</style>
